import {
  LitElement,
  css,
  html,
} from "https://cdn.jsdelivr.net/gh/lit/dist@3/core/lit-core.min.js";

class SkioAddToSubscription extends LitElement {
  static styles = css`
    :host {
      --color-primary:#6941c6; 
      --color-accent: #fff;
      --color-bg: #f7f2ee; 
      --color-card-bg: #f5f5f5; 
      --color-border: #e0e0e0; 
      --color-text: #333; 
      --color-muted: #666; 
      --color-strikethrough: #999; 
      position: relative;
      display: block;
      font-family: inherit;
      font-size: 16px;
    }
    .callout {
      background: var(--color-card-bg);
      border-radius: 8px;
      padding: 24px;
      margin-bottom: 24px;
      border: 1px solid var(--color-border);
      position: relative;
    }
    .callout h3 {
      margin: 0;
      font-size: 1em;
      font-weight: 700;
      color: var(--color-text);
    }
    .callout small {
      display: block;
      margin-bottom: 16px;
    }
    .callout p {
      margin: 0 0 16px 0;
      color: var(--color-muted);
      font-size: 0.9em;
    }
    .add-to-subscription-button {
      background: var(--color-primary);
      color: var(--color-accent);
      border: none;
      border-radius: 4px;
      padding: 12px 0;
      width: 100%;
      font-size: 0.9em;
      font-weight: 700;
      cursor: pointer;
      transition: background 0.2s;
      text-transform: uppercase;
    }
    .add-to-subscription-button:hover {
      background: color-mix(in srgb, var(--color-primary) 80%, black);
    }
    dialog {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin: 0;
      z-index: 2147483647;
      background: var(--color-accent);
      border-radius: 12px;
      border: none;
      width: 100%;
      max-width: 500px;
      padding: 0;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
    }
    dialog::backdrop {
      background: rgba(0, 0, 0, 0.5);
    }
    .modal-content {
      position: relative;
    }
    .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 16px;
      padding: 16px 32px 16px 32px;
      border-bottom: 1px solid var(--color-border);
    }
    .modal-title {
      font-size: 1.1em;
      font-weight: 700;
      color: var(--color-text);
      margin: 0;
      line-height: 1.3;
    }
    .modal-title .date-badge {
      border: 2px solid var(--color-primary);
      border-radius: 4px;
      padding: 2px 8px;
      font-size: 0.8em;
      color: var(--color-primary);
      font-weight: 500;
      background: var(--color-accent);
      display: inline-block;
    }
    .close-button {
      background: none;
      border: none;
      font-size: 2em;
      color: var(--color-muted);
      cursor: pointer;
      padding: 0;
      margin: 0;
      width: 2em;
      height: 2em;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
    }
    .close-button:hover {
      color: var(--color-text);
    }
    form {
      padding: 24px 32px;
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
    .option-label {
      display: flex;
      align-items: center;
      gap: 8px;
      background: var(--color-card-bg);
      border: 1px solid var(--color-border);
      border-radius: 8px;
      padding: 12px;
      cursor: pointer;
      transition: border 0.2s, background 0.2s;
      position: relative;
    }
    .option-label:hover {
      border-color: var(--color-primary);
    }
    .option-label.selected {
      border: 2px solid var(--color-primary);
      background: var(--color-accent);
    }
    .option-label input[type="radio"] {
      accent-color: var(--color-primary);
      width: 1.5em;
      height: 1.5em;
      flex-shrink: 0;
    }
    .option-content {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      gap: 4px;
    }
    .option-title {
      font-size: 1em;
      font-weight: 700;
      color: var(--color-text);
    }
    .delivery-policy {
      font-size: 0.8em;
      color: var(--color-muted);
      font-weight: 500;
      text-transform: capitalize;
    }
    .discount-badge {
      background: var(--color-primary);
      color: var(--color-accent);
      font-weight: 700;
      border-radius: 4px;
      padding: 4px 12px;
      font-size: 0.8em;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
    .price-container {
      margin-left: auto;
      text-align: right;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 2px;
    }
    .original-price {
      text-decoration: line-through;
      color: var(--color-strikethrough);
      font-size: 0.9em;
      font-weight: 500;
    }
    .discounted-price {
      color: var(--color-primary);
      font-size: 1em;
      font-weight: 700;
    }
    .modal-policy {
      font-size: 0.8em;
      color: var(--color-muted);
      padding: 0px 32px 16px 32px;
    }
    .modal-footer {
      display: flex;
      gap: 16px;
      padding: 24px 32px 32px 32px;
      border-top: 1px solid var(--color-border);
    }
    .modal-footer button {
      flex: 1;
      padding: 16px 24px;
      border-radius: 4px;
      font-size: 0.9em;
      font-weight: 700;
      border: none;
      cursor: pointer;
      transition: all 0.2s;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
    .primary-button {
      background: var(--color-primary);
      color: var(--color-accent);
    }
    .primary-button:hover {
      background: color-mix(in srgb, var(--color-primary) 80%, black);
    }
    .secondary-button {
      background: transparent;
      color: var(--color-text);
      border: 2px solid var(--color-border);
    }
    .secondary-button:hover {
      background: var(--color-card-bg);
      border-color: var(--color-primary);
    }
    .success-screen {
      background: #e8f5e8;
      border: 2px solid #4caf50;
      border-radius: 8px;
      padding: 24px;
      margin-bottom: 24px;
      text-align: left;
    }
    .success-title {
      font-size: 1em;
      font-weight: 700;
      color: var(--color-text);
      margin: 0 0 16px 0;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
    .success-message {
      font-size: 0.9em;
      color: var(--color-text);
      margin: 0 0 8px 0;
      line-height: 1.4;
    }
    .success-date {
      font-weight: 700;
      color: var(--color-text);
    }
    .success-link {
      color: var(--color-primary);
      text-decoration: none;
      font-weight: 700;
      font-size: 0.9em;
      margin-top: 16px;
      display: inline-block;
      transition: color 0.2s;
    }
    .success-link:hover {
      color: color-mix(in srgb, var(--color-primary) 80%, black);
      text-decoration: underline;
    }
    .loading-spinner {
      display: inline-block;
      width: 16px;
      height: 16px;
      border: 2px solid var(--color-accent);
      border-radius: 50%;
      border-top-color: transparent;
      animation: spin 1s linear infinite;
      margin-right: 8px;
    }
    @keyframes spin {
      to { transform: rotate(360deg); }
    }
    .primary-button:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
    .error-message {
      background: #fee;
      border: 1px solid #fcc;
      border-radius: 4px;
      padding: 12px;
      margin-bottom: 16px;
      color: #c33;
      font-size: 0.9em;
      text-align: center;
    }
    @media(max-width: 500px) {
      .modal-footer {
        flex-direction: column;
        gap: 8px;
        padding: 12px 16px 16px 16px
      }
      .modal-header {
        padding: 12px 16px 12px 16px;
      }
      form {
        padding: 12px 16px;
      }
      .modal-policy {
        padding: 0px 16px 16px 16px;
      }
    }
  `;

  static properties = {
    isLoading: { type: Boolean },
    isAuthenticated: { type: Boolean },
    productId: { type: String },
    product: { type: Object },
    selectedVariant: { type: Object },
    upcomingSubscription: { type: Object },
    eligibleForSubscription: { type: Boolean },
    eligibleForOneTimeUpsell: { type: Boolean },
    oneTimeUpsellPercentageOff: { type: Number },
    selectedOption: { type: String },
    selectedSellingPlan: { type: Object },
    showSuccessScreen: { type: Boolean },
    previouslyAddedProducts: { type: String },
    isAddingToSubscription: { type: Boolean },
    addToSubscriptionError: { type: String },
  };

  constructor() {
    super();
    this.initializeDefaultState();
  }

  async connectedCallback() {
    super.connectedCallback();
    await this.initialize();
    this.isLoading = false;
    this.bindFormEvents();
  }

  initializeDefaultState() {
    this.isLoading = false;
    this.eligibleForSubscription = false;
    this.eligibleForOneTimeUpsell = false;
    this.selectedOption = "subscription";
    this.showSuccessScreen = false;
    this.isAddingToSubscription = false;
    this.addToSubscriptionError = null;
  }

  async initialize() {
    this.checkAuthentication();
    if (!this.isAuthenticated) return;

    const subscription = await this.fetchUpcomingSubscription();
    this.upcomingSubscription = subscription;

    const product = await this.fetchProduct();
    this.product = product;
  }

  checkAuthentication() {
    this.isAuthenticated = !!window.Skio?.storefrontUser?.idToken;
  }

  async fetchUpcomingSubscription() {
    const cachedSubscription = localStorage.getItem("upcoming-subscription");

    // Uncomment to enable caching
    if (cachedSubscription) {
      return JSON.parse(cachedSubscription);
    }

    const query = `
      query storefrontGetUpcomingSubscription($storefrontUserId: uuid) {
        Subscriptions(where: {
          status: {
            _eq: "ACTIVE"
          }
          storefrontUserId: {
            _eq: $storefrontUserId
          }
        }, order_by: {
          nextBillingDate: asc
        }, limit: 1) {
          id
          status
          nextBillingDate
          SubscriptionLines(
            where: { removedAt: { _is_null: true } }
            limit: 1
            order_by: { createdAt: asc }
          ) {
            OriginalSellingPlan {
              PricingPolicies {
                percentageOff
                fixedPrice
              }
            }
          }
          DeliveryPolicy { 
            interval 
            intervalCount 
          }
          BillingPolicy {
            interval
            intervalCount
          }
        }
      }
    `;

    const variables = {
      storefrontUserId: window.Skio?.storefrontUser?.id,
    };

    try {
      const response = await window.Skio.graphQLRequest({ query, variables });
      const subscription = response.data.Subscriptions[0];

      // Cache the subscription
      localStorage.setItem(
        "upcoming-subscription",
        JSON.stringify(subscription)
      );

      // Filter out prepaid subscriptions
      if (this.isPrepaidSubscription(subscription)) {
        return null;
      }

      return subscription;
    } catch (error) {
      console.error("Error fetching upcoming subscription:", error);
      return null;
    }
  }

  async fetchProduct() {
    const query = `
      query Products($where: Product_bool_exp) {
        Products(where: $where) {
          title
          canUpsell
          oneTimeUpsellPercentageOff
          ProductVariants {
            enableOneTimeUpsell
            platformId
            price
            compareAtPrice
            SellingPlanGroupResources(where: {SellingPlanGroup: { name: { _eq: "Subscription" } }}) {
              SellingPlanGroup {
                customName
                SellingPlans {
                  id
                  platformId
                  PricingPolicies {
                    percentageOff
                    fixedPrice
                  }
                  DeliveryPolicy {
                    interval
                    intervalCount
                  }
                }
              }
            }
          }
        }
      }
    `;

    const variables = {
      where: {
        platformId: {
          _eq: `gid://shopify/Product/${this.productId}`,
        },
      },
    };

    try {
      const response = await window.Skio.graphQLRequest({ query, variables });
      console.log("Product data:", response.data.Products[0]);
      return response.data.Products[0];
    } catch (error) {
      console.error("Error fetching product:", error);
      return null;
    }
  }

  isPrepaidSubscription(subscription) {
    const { DeliveryPolicy, BillingPolicy } = subscription;
    return (
      DeliveryPolicy.interval !== BillingPolicy.interval ||
      DeliveryPolicy.intervalCount !== BillingPolicy.intervalCount
    );
  }

  formatDate(timestamp) {
    const date = new Date(timestamp);
    return `${date.toLocaleString("en-US", {
      month: "short",
    })} ${date.getDate()}, ${date.getFullYear()}`;
  }

  formatMoney(amount) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount);
  }

  bindFormEvents() {
    const variantInput = document.querySelector("[name=id]");
    if (!variantInput) return;

    this.updateSelectedVariant(variantInput.value);
    this.checkVariantEligibility(this.selectedVariant);
    this.checkPreviouslyAddedProducts();

    variantInput.addEventListener("change", (e) => {
      this.updateSelectedVariant(e.target.value);
      this.checkVariantEligibility(this.selectedVariant);
      this.checkPreviouslyAddedProducts();
    });
  }

  checkPreviouslyAddedProducts() {
    let previouslyAddedProducts =
      window.sessionStorage.getItem("skio_upsell_added_products") || "";
    if (previouslyAddedProducts.includes(this.selectedVariant.platformId)) {
      this.showSuccessScreen = true;
    } else {
      this.showSuccessScreen = false;
    }
  }

  updateSelectedVariant(variantId) {
    this.selectedVariant = this.product.ProductVariants.find((variant) =>
      variant.platformId.includes(variantId)
    );
  }

  checkVariantEligibility(variant) {
    if (!variant) return;

    this.eligibleForOneTimeUpsell =
      variant.enableOneTimeUpsell && this.product.canUpsell;

    this.eligibleForSubscription = variant.SellingPlanGroupResources.length > 0;

    if (!this.eligibleForOneTimeUpsell) {
      this.selectedOption = "subscription";
    }
  }

  getSubscriptionPrice() {
    const sellingPlanGroup = this.findMatchingSellingPlanGroup();
    const sellingPlan = this.findMatchingSellingPlan(sellingPlanGroup);

    if (!sellingPlan)
      return {
        discount: null,
        price: this.formatMoney(this.selectedVariant.price),
      };

    this.selectedSellingPlan = sellingPlan;

    const pricingPolicy = sellingPlan.PricingPolicies[0];
    let discount, price;

    if (pricingPolicy.percentageOff) {
      discount = `${pricingPolicy.percentageOff}%`;
      price =
        this.selectedVariant.price * (1 - pricingPolicy.percentageOff / 100);
    } else if (pricingPolicy.fixedPrice) {
      discount = this.formatMoney(pricingPolicy.fixedPrice);
      price = this.selectedVariant.price - pricingPolicy.fixedPrice;
    }

    return {
      discount,
      price: this.formatMoney(price),
    };
  }

  getOneTimePrice() {
    if (!this.product.oneTimeUpsellPercentageOff) {
      return {
        discount: null,
        price: this.formatMoney(this.selectedVariant.price),
      };
    }

    const discount = `${this.product.oneTimeUpsellPercentageOff * 100}%`;
    const price =
      this.selectedVariant.price *
      (1 - this.product.oneTimeUpsellPercentageOff);

    return {
      discount,
      price: this.formatMoney(price),
    };
  }

  findMatchingSellingPlanGroup() {
    console.log(this.selectedVariant)
    return this.selectedVariant.SellingPlanGroupResources.find((group) =>
      group.SellingPlanGroup.SellingPlans.some((plan) =>
        this.isMatchingDeliveryPolicy(plan.DeliveryPolicy)
      )
    );
  }

  findMatchingSellingPlan(sellingPlanGroup) {
    if (!sellingPlanGroup) return null;

    return sellingPlanGroup.SellingPlanGroup.SellingPlans.find((plan) =>
      this.isMatchingDeliveryPolicy(plan.DeliveryPolicy)
    );
  }

  isMatchingDeliveryPolicy(deliveryPolicy) {
    return (
      deliveryPolicy.interval ===
        this.upcomingSubscription.DeliveryPolicy.interval &&
      deliveryPolicy.intervalCount ===
        this.upcomingSubscription.DeliveryPolicy.intervalCount
    );
  }

  async addToSubscription() {
    // Clear any previous errors and set loading state
    this.addToSubscriptionError = null;
    this.isAddingToSubscription = true;

    const productVariantPlatformId = this.selectedVariant.platformId;
    const sellingPlanPlatformId = this.selectedSellingPlan.platformId;
    const isOneTimeUpsell = this.selectedOption === "one-time";
    const subscriptionId = this.upcomingSubscription.id;

    const mutation = `
      mutation storefrontEditSubscriptionLines($input: EditSubscriptionLinesInput!) {
        editSubscriptionLines(input: $input) {
          subscriptionId
        }
      }
    `;

    const variables = {
      input: {
        subscriptionId,
        subscriptionLinesToCreate: [
          {
            customAttributes: [
              {
                key: "add-to-subscription-component",
                value: "true"
              }
            ],
            productVariantPlatformId,
            quantity: 1,
            isOneTimeUpsell,
          },
        ],
      },
    };

    console.log("Adding to subscription:", { mutation, variables });

    try {
      const response = await window.Skio.graphQLRequest({
        query: mutation,
        variables,
      });

      // Close modal and show success screen
      this.closeModal();
      let previouslyAddedProducts =
        window.sessionStorage.getItem("skio_upsell_added_products") || "";
      window.sessionStorage.setItem(
        "skio_upsell_added_products",
        `${previouslyAddedProducts}, ${this.selectedVariant.platformId}`
      );

      this.showSuccessScreen = true;

      return response;
    } catch (error) {
      console.error("Error adding to subscription:", error);
      this.addToSubscriptionError = "Error adding to subscription. Please try again.";
      return error;
    } finally {
      this.isAddingToSubscription = false;
    }
  }

  openModal() {
    const dialog = this.shadowRoot.querySelector("dialog");
    if (dialog) {
      dialog.showModal();
      this.setupModalEventListeners(dialog);
    }
  }

  closeModal() {
    const dialog = this.shadowRoot.querySelector("dialog");
    if (dialog) {
      dialog.close();
      this.removeModalEventListeners(dialog);
    }
  }

  setupModalEventListeners(dialog) {
    dialog.addEventListener("click", this.handleBackdropClick.bind(this));
  }

  removeModalEventListeners(dialog) {
    dialog.removeEventListener("click", this.handleBackdropClick.bind(this));
  }

  handleBackdropClick(e) {
    if (e.target.tagName === "DIALOG") {
      this.closeModal();
    }
  }

  renderModal() {
    const oneTimePrice = this.getOneTimePrice();
    const subscriptionPrice = this.getSubscriptionPrice();

    return html`
      <dialog>
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title">
              Add to Subscription
              <span class="date-badge"
                >${this.formatDate(
                  this.upcomingSubscription.nextBillingDate
                )}</span
              >
            </h2>
            <button class="close-button" @click=${this.closeModal}>
              &times;
            </button>
          </div>
          <form>
            ${this.addToSubscriptionError
              ? html`<div class="error-message">${this.addToSubscriptionError}</div>`
              : null}
            ${this.eligibleForOneTimeUpsell
              ? this.renderOneTimeOption(oneTimePrice)
              : null}
            ${this.eligibleForSubscription
              ? this.renderSubscriptionOption(subscriptionPrice)
              : null}
          </form>
            
          <div class="modal-policy">
            ${this.selectedOption === 'subscription' ? 
              html`<small>By clicking Add to Order, you’re adding this item to your subscription. You’ll be charged automatically at the listed price and frequency until canceled. All cancellations are subject to the <a href="/policies/subscription-policy">cancellation policy</a>.</small>`
            : html`<small>By selecting Add to Order, you agree to a one-time charge for this item, which will be added to your next subscription shipment. This item will not renew or be billed again. All cancellations are subject to the <a href="/policies/subscription-policy">cancellation policy</a>.</small>`}
          </div>
          
          <div class="modal-footer">
            <button 
              class="primary-button" 
              @click=${this.addToSubscription}
              ?disabled=${this.isAddingToSubscription}
            >
              ${this.isAddingToSubscription
                ? html`<span class="loading-spinner"></span>`
                : "ADD TO ORDER"}
            </button>
            <button
              class="secondary-button"
              @click=${this.closeModal}
              type="button"
              ?disabled=${this.isAddingToSubscription}
            >
              Cancel
            </button>
          </div>
        </div>
      </dialog>
    `;
  }

  renderOneTimeOption(oneTimePrice) {
    const isSelected = this.selectedOption === "one-time";

    return html`
      <label
        class="option-label ${isSelected ? "selected" : ""}"
        @click=${() => (this.selectedOption = "one-time")}
      >
        <input
          type="radio"
          name="addType"
          value="one-time"
          .checked=${isSelected}
          @change=${() => (this.selectedOption = "one-time")}
        />
        <div class="option-content">
          <span class="option-title">Get One-Time</span>
        </div>
        ${oneTimePrice.discount
            ? html`<span class="discount-badge text-2xl"
                >Save ${oneTimePrice.discount}</span
              >`
            : null}
        <div class="price-container">
          ${this.getOriginalPrice() === oneTimePrice.price ? null : html`<span class="original-price"> ${this.getOriginalPrice()} </span>`}
          <span class="discounted-price">${oneTimePrice.price}</span>
        </div>
      </label>
    `;
  }

  renderSubscriptionOption(subscriptionPrice) {
    const isSelected = this.selectedOption === "subscription";

    return html`
      <label
        class="option-label ${isSelected ? "selected" : ""}"
        @click=${() => (this.selectedOption = "subscription")}
      >
        <input
          type="radio"
          name="addType"
          value="subscription"
          .checked=${isSelected}
          @change=${() => (this.selectedOption = "subscription")}
        />
        <div class="option-content">
          <span class="option-title">Subscribe</span>
          <div class="delivery-policy">
            Every ${this.upcomingSubscription.DeliveryPolicy.intervalCount}
            ${this.upcomingSubscription.DeliveryPolicy.interval.toLowerCase()}
          </div>
        </div>
        ${subscriptionPrice.discount
            ? html`<span class="discount-badge"
                >Save ${subscriptionPrice.discount}</span
              >`
            : null}
        <div class="price-container">
          ${this.getOriginalPrice() === subscriptionPrice.price ? null : html`<span class="original-price"> ${this.getOriginalPrice()} </span>`}
          <span class="discounted-price">${subscriptionPrice.price}</span>
        </div>
      </label>
    `;
  }

  getOriginalPrice() {
    return this.selectedVariant.compareAtPrice
      ? this.formatMoney(this.selectedVariant.compareAtPrice)
      : this.formatMoney(this.selectedVariant.price);
  }

  renderSuccessScreen() {
    return html`
      <div class="success-screen">
        <h2 class="success-title">Added to Your Next Order</h2>
        <p class="success-message">
          This item will be included in your next subscription order shipment on
          <span class="success-date"
            >${this.formatDate(this.upcomingSubscription.nextBillingDate)}</span
          >
        </p>
        <a href="/a/account/subscriptions" class="success-link">
          View and manage my subscriptions ->
        </a>
      </div>
    `;
  }

  render() {
    if (!this.shouldRender()) {
      return null;
    }

    // Show success screen if item was added successfully
    if (this.showSuccessScreen) {
      return this.renderSuccessScreen();
    }

    return html`
      <div class="callout">
        <h3>Add to Upcoming Subscription</h3>
        <small>You can easily add this item to your upcoming subscription order.</small>
        <p>
          Next order on:
          <b>${this.formatDate(this.upcomingSubscription.nextBillingDate)}</b>
        </p>
        <button
          class="add-to-subscription-button"
          @click=${() => this.openModal()}
        >
          Add to next order and save
        </button>
      </div>
      ${this.renderModal()}
    `;
  }

  shouldRender() {
    return (
      this.isAuthenticated &&
      this.upcomingSubscription &&
      this.eligibleForSubscription &&
      this.selectedVariant
    );
  }
}

customElements.define("skio-add-to-subscription", SkioAddToSubscription);